import React from 'react';
import PropertyAlgolia from "./PropertyAlgolia";
import DescCut from "./DescCut";
import { isNotEmpty } from "../../util/user";
import algoliasearch from "algoliasearch";
import { Link, withRouter } from 'react-router-dom';
import loading from '../../images/loading.png';
import header_two_ham from '../../images/header_two_ham.jpg';
import header from '../../images/header.jpg';
import VidBox from '../VidBox'
import CustomPage from './CustomPage'
import SearchCats from '../SearchCats'

function compare(a, b) {
  if (parseInt(a.objectID) < parseInt(b.objectID)) {
    return 1;
  }
  if (parseInt(a.objectID) > parseInt(b.objectID)) {
    return -1;
  }
  // a must be equal to b
  return 0;
}


class Listings extends React.Component {
  constructor(props) {
    var client = algoliasearch('PTGN8U7BAB', '1bd38ecdf030101a4cff6d2447e8de2e');

    super(props);
    this.state = {
      results: [],
      custom_pages: [],
      imageCompanies: [],
      loading: true,
      searchingFor: "",
      priceMax: undefined,
      priceMin: undefined,
      currentPage: 0,
      pageTotal: 10,
      pageSize: 9,
      header: 1,
      client: client,
      textToShow: "job"
    };

    this.Listings = React.createRef();
    this.searchListings = this.searchListings.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this);
  }

  handleChange(field, e) {
    const state = this;
    this.setState({[field]: e.target.value});
  }

  searchListings(e) {
    const search = e != undefined ? e.target.value.trim() : this.state.searchingFor;
    this.setState({ searchingFor: search });
    const state = this;

    // state.setState({loading: true});

    if (this.state.client !== undefined) {
      // var index = this.state.client.initIndex(process.env.REACT_APP_ALGOLIA,);
      let priceFacets = []
      // if (state.state.priceMax != undefined && state.state.priceMin != undefined) {
      priceFacets = [`ListPrice>=10000`]
      // }

      const listingQuery = {
        indexName: process.env.REACT_APP_ALGOLIA,
        params: {
          query: search,
          page: this.state.currentPage, // algolia starts at 0 for pages
          hitsPerPage: this.state.pageSize,
          attributesToRetrieve: '*',
          attributesToHighlight: [],
          numericFilters: priceFacets,
          facetFilters: []
        }
      };

      this.state.client.search([listingQuery]).then((data) => {
        let results = (data.results[0].hits || []).filter((result) => isNotEmpty(result.Image));
        results = results.slice(0, this.state.pageSize);
        let stateResults = this.state.results;
        stateResults = stateResults.concat(results);
        stateResults = stateResults.sort(compare);
        state.setState({loading: false});
        state.setState({results: stateResults});
        state.setState({pageTotal: data.results[0].nbPages})
      });
    }
  }

  searchBlog(e) {
    const state = this;

    const token = localStorage.getItem("auth_token");
    var myHeaders = new Headers({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    });

    var myInit = {
      method: 'GET',
      headers: myHeaders
    };

    let url = `${process.env.REACT_APP_API_HOST}/api/custom_pages`

    if (isNotEmpty(this.state.subcategoryParam)) {
      url = `${process.env.REACT_APP_API_HOST}/api/custom_pages?subcategory=${this.state.subcategoryParam}`
    }

    var myRequest = new Request(`${url}`, myInit);

    fetch(myRequest)
    .then((json) => json.json())
    .then((content) => {
      state.setState({
        custom_pages: content.custom_pages.slice(0, 6),
        mounted: true,
        loading: false
      });

      return content;
    });

  }

  _handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.goToSearch()
    }
  }

  goToSearch() {
    const url = `/browse?search=${encodeURIComponent(this.state.searchingFor)}&min_price=${encodeURIComponent(this.state.priceMin)}&max_price=${encodeURIComponent(this.state.priceMax)}`;
    this.props.history.push(url);
  }

  componentDidMount() {
    this.searchListings();
    this.searchBlog();
  }

  render() {
    let show;
    let communities = [
      {
        name: "Ancaster",
        slug: "Ancaster",
        img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.shawnpalmer.ca%2Fimages%2Fcontent%2FAncaster-Ontario-street-view.jpg&f=1&nofb=1"
      },
      {
        name: "Brantford",
        slug: "Brantford",
        img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.narcity.com%2Fu%2F2018%2F04%2F18%2F25877367f1ed5beec4bafbbf2a2c5edf9474feb3.jpg_1200x630.jpg&f=1&nofb=1"
      },
      {
        name: "Burlington",
        slug: "Burlington",
        img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.mcsrealestatewebsites.com%2FAssets%2FNeighbourhoods%2Fburlington-2.jpg&f=1&nofb=1"
      },
      {
        name: "Dundas",
        slug: "Dundas",
        img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fimages.dailyhive.com%2F20170127065907%2FTravis-Singleton-%254020two19-Photography2.jpg&f=1&nofb=1"
      },
      {
        name: "Flamborough",
        slug: "Flamborough",
        img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.realtor.ca%2Flisting%2FTS636959526321700000%2Freb14%2Fhighres%2F6%2Fh4056186_2.jpg&f=1&nofb=1"
      },
      {
        name: "Grimsby",
        slug: "Grimsby",
        img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fpostmediatorontosun.files.wordpress.com%2F2018%2F02%2Fcover-image-main-street-and-ontario-street-cropped.jpg&f=1&nofb=1"
      },
      {
        name: "Hamilton",
        slug: "Hamilton",
        img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fcommons%2Fthumb%2F1%2F11%2FNorthEndHamilton.JPG%2F1200px-NorthEndHamilton.JPG&f=1&nofb=1"
      },
      {
        name: "Niagara",
        slug: "Niagara",
        img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2F3.bp.blogspot.com%2F-b-2uzfhW2Fo%2FT5zRwgcckdI%2FAAAAAAAAJRo%2FG0p7LiZoGbk%2Fs1600%2FOntario_Canada_Niagara_Falls.jpg&f=1&nofb=1"
      },
      {
        name: "Oakville",
        slug: "Oakville",
        img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fplumber.ca%2Fwp-content%2Fuploads%2F2013%2F06%2Fo-OAKVILLE-ONTARIO-facebook.jpg&f=1&nofb=1"
      },
      {
        name: "Stoney Creek",
        slug: "Stoney Creek",
        img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fvignette.wikia.nocookie.net%2Fprowrestling%2Fimages%2F7%2F79%2FStoney_Creek%252C_ON.jpg%2Frevision%2Flatest%3Fcb%3D20150104013334&f=1&nofb=1"
      },
      {
        name: "Waterdown",
        slug: "Waterdown",
        img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2F3.bp.blogspot.com%2F-b-2uzfhW2Fo%2FT5zRwgcckdI%2FAAAAAAAAJRo%2FG0p7LiZoGbk%2Fs1600%2FOntario_Canada_Niagara_Falls.jpg&f=1&nofb=1"
      }
    ]

    if (this.state.loading) {
      show = <div id="loading-state"><img src={loading} /></div>
    } else {
      show = <div className="row all-jobs-row">
        <div ref={this.Listings} className="parallax bg2 container" id="jobs-container">
          {this.state.results.map(function(listing, index) {
            return (
              <span key={"job-result" + index} className="job-ctn">
                <PropertyAlgolia result={listing} />
              </span>
            )
          })}
        </div>
      </div>
    }

    // <iframe src="https://www.youtube.com/embed/W0LHTWG-UmQ?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&playlist=W0LHTWG-UmQ" frameborder="0" allowfullscreen></iframe>
    return (
      <div className="ctn-jobs wrapper">
        <VidBox />

        <div className="bigger-zindex all-jobs">
          {show}
        </div>
      </div>
    )
  }
};

export default withRouter(Listings);
